import { categoryList, newsDelete, newsListing } from "api/news";
import CreateNews from "components/CreateNews";
import DetailsPage from "components/Details";
import useDebounce from "hook/useDebounce";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ButtonComp from "themes/elements/Button";
import ModalComp from "themes/elements/Modal";
import TabComp from "themes/elements/Tab";
import NewsTable from "themes/elements/Table/NewsTable/index";
import { retrieveUserData } from "utils/cryptoStorage";
import { isPermit } from "utils/permissionCheck";

function NewsManagement() {
  const userToken = retrieveUserData();
  let admin_user_id, admin_user_name;

  if (userToken) {
    ({ admin_user_id, admin_user_name } = userToken);
  }
  const [news, setNews] = useState(false);
  const [details, setDetails] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [loadCategory, setLoadCategory] = useState(false);
  const [newsData, setNewsData] = useState([]);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPageNo, setTotalPageNo] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [selectedNews, setSelectedNews] = useState(null);
  const [isEdit, setEdit] = useState(false);
  const [status, setStatus] = useState(4);
  const [tabActive, setTabActive] = useState("1");
  const [dlt, setDlt] = useState(false);
  const [duplicate, setDuplicate] = useState(false);
  // filter states
  const [filterTitle, setFilterTitle] = useState("");
  const [filterAuthor, setFilterAuthor] = useState("");
  const [filterExpiry, setFilterExpiry] = useState(null);
  const [filterPublish, setFilterPublish] = useState(null);
  const [filterCategory, setFilterCategory] = useState("");

  useEffect(() => {
    const loadWards = async () => {
      try {
        const category = await categoryList();
        const formattedCategory = category?.data?.categories?.map((cat) => ({
          id: cat?.news_category_id,
          name: cat?.news_category_name,
          color: cat?.tag_color,
          status: cat?.category_status_flg,
        }));
        setCategoryData(formattedCategory);
      } catch (error) {}
    };
    loadWards();
  }, [loadCategory]);

  const handleEdit = (data) => {
    setSelectedNews(data);
    setDuplicate(false);
    setEdit(true);
    setNews(true);
  };

  const dltModalFooter = (
    <div className="flex align-center justify-end gap-3">
      <ButtonComp onClick={() => setDlt(null)} variant="secondary">
        Cancel
      </ButtonComp>
      <ButtonComp
        variant="danger"
        loading={isLoading}
        onClick={() => {
          handleNewsDelete(selectedNews?.id);
        }}
      >
        Delete
      </ButtonComp>
    </div>
  );

  const columnData = [
    {
      title: "Title",
      avatar: true,
      filter: "searchTitle",
      width: 312,
    },
    {
      title: "Category",
      filter: "selectCategory",
      dropDown: categoryData?.map((data) => ({
        name: data?.name,
        value: data?.id,
      })),
      width: 163,
      chip: true,
    },
    {
      title: "Author",
      filter: "searchRecipients",
      width: 189,
      avatar: true,
    },

    {
      title: "Expiry date",
      filter: "datePickerExpiry",
      width: 170,
      expiryDate: true,
    },
  ];

  // Dynamically add a column before the "Expiry Date" column (position 3)
  if (tabActive === "1" || tabActive === "3") {
    const newColumn = {
      title:
        tabActive === "1"
          ? "Published Date"
          : tabActive === "3"
          ? "Alert Date"
          : tabActive === "2"
          ? "Submitted Date"
          : tabActive === "4"
          ? "Created Date"
          : "Created Date",
      filter: "datePickerAlert",
      width: 204,
      publishDate: true,
    };

    columnData && columnData?.splice(3, 0, newColumn);
  }

  const handleNewsDelete = async (newsId) => {
    setIsLoading(true);
    try {
      const response = await newsDelete({
        newsId: Number(newsId),
      });
      fetchNews();
      if (response.statusCode === 200) {
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
      setIsLoading(false);
      setDlt(false);
    } catch (error) {
      toast.error(error);
      setIsLoading(false);
      setDlt(false);
    }
  };

  const onDeleteClick = (data) => {
    setSelectedNews(data);
    setDlt(true);
  };

  const handleDuplicate = (data) => {
    setSelectedNews(data);
    setEdit(false);
    setDuplicate(true);
    setNews(true);
    setCurrentPageNo(1);
  };

  const tabsData = [
    {
      key: "1",
      label: "Published",
      children: (
        <>
          {" "}
          {tabActive === "1" && (
            <NewsTable
              onDeleteAction={onDeleteClick}
              isLoading={isLoading}
              pageSize={pageSize}
              setPageSize={setPageSize}
              dataClick={(data) => {
                setDetails(true);
                setSelectedNews(data);
              }}
              editAction={false}
              totalPageNo={totalPageNo}
              handleEdit={handleEdit}
              column={columnData}
              data={newsData}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
              setCurrentPageNo={setCurrentPageNo}
              currentPageNo={currentPageNo}
              tabActive={tabActive}
              handleDuplicate={handleDuplicate}
              filterTitle={filterTitle}
              setFilterTitle={setFilterTitle}
              filterAuthor={filterAuthor}
              setFilterAuthor={setFilterAuthor}
              setFilterPublish={setFilterPublish}
              setFilterExpiry={setFilterExpiry}
              setFilterCategory={setFilterCategory}
            />
          )}
        </>
      ),
    },
    {
      key: "2",
      label: "Submitted",
      children: (
        <>
          {tabActive === "2" && (
            <NewsTable
              editAction={false}
              onDeleteAction={onDeleteClick}
              isLoading={isLoading}
              pageSize={pageSize}
              setPageSize={setPageSize}
              dataClick={(data) => {
                setDetails(true);
                setSelectedNews(data);
              }}
              totalPageNo={totalPageNo}
              column={columnData}
              data={newsData}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
              setCurrentPageNo={setCurrentPageNo}
              handleEdit={handleEdit}
              tabActive={tabActive}
              currentPageNo={currentPageNo}
              handleDuplicate={handleDuplicate}
              filterTitle={filterTitle}
              setFilterTitle={setFilterTitle}
              filterAuthor={filterAuthor}
              setFilterAuthor={setFilterAuthor}
              setFilterPublish={setFilterPublish}
              setFilterExpiry={setFilterExpiry}
              setFilterCategory={setFilterCategory}
            />
          )}
        </>
      ),
    },
    {
      key: "3",
      label: "Scheduled",
      children: (
        <>
          {tabActive === "3" && (
            <NewsTable
              editAction={false}
              onDeleteAction={onDeleteClick}
              isLoading={isLoading}
              pageSize={pageSize}
              setPageSize={setPageSize}
              dataClick={(data) => {
                setDetails(true);
                setSelectedNews(data);
              }}
              totalPageNo={totalPageNo}
              currentPageNo={currentPageNo}
              handleEdit={handleEdit}
              column={columnData}
              data={newsData}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
              setCurrentPageNo={setCurrentPageNo}
              tabActive={tabActive}
              handleDuplicate={handleDuplicate}
              filterTitle={filterTitle}
              setFilterTitle={setFilterTitle}
              filterAuthor={filterAuthor}
              setFilterAuthor={setFilterAuthor}
              setFilterPublish={setFilterPublish}
              setFilterExpiry={setFilterExpiry}
              setFilterCategory={setFilterCategory}
            />
          )}
        </>
      ),
    },
    {
      key: "4",
      label: "Rejected",
      children: (
        <>
          {tabActive === "4" && (
            <NewsTable
              editAction={true}
              onDeleteAction={onDeleteClick}
              isLoading={isLoading}
              pageSize={pageSize}
              setPageSize={setPageSize}
              dataClick={(data) => {
                setDetails(true);
                setSelectedNews(data);
              }}
              copyAction={false}
              totalPageNo={totalPageNo}
              handleEdit={handleEdit}
              column={columnData}
              data={newsData}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
              currentPageNo={currentPageNo}
              setCurrentPageNo={setCurrentPageNo}
              tabActive={tabActive}
              handleDuplicate={handleDuplicate}
              filterTitle={filterTitle}
              setFilterTitle={setFilterTitle}
              filterAuthor={filterAuthor}
              setFilterAuthor={setFilterAuthor}
              setFilterPublish={setFilterPublish}
              setFilterExpiry={setFilterExpiry}
              setFilterCategory={setFilterCategory}
            />
          )}
        </>
      ),
    },
    {
      key: "5",
      label: "Drafts",
      children: (
        <>
          {tabActive === "5" && (
            <NewsTable
              editAction={true}
              onDeleteAction={onDeleteClick}
              isLoading={isLoading}
              copyAction={false}
              pageSize={pageSize}
              setPageSize={setPageSize}
              dataClick={(data) => {
                setDetails(true);
                setSelectedNews(data);
              }}
              totalPageNo={totalPageNo}
              handleEdit={handleEdit}
              column={columnData}
              data={newsData}
              selectedData={selectedData}
              currentPageNo={currentPageNo}
              setSelectedData={setSelectedData}
              setCurrentPageNo={setCurrentPageNo}
              tabActive={tabActive}
              filterTitle={filterTitle}
              setFilterTitle={setFilterTitle}
              filterAuthor={filterAuthor}
              setFilterAuthor={setFilterAuthor}
              setFilterPublish={setFilterPublish}
              setFilterExpiry={setFilterExpiry}
              setFilterCategory={setFilterCategory}
            />
          )}
        </>
      ),
    },
  ];

  function handleTabChange(key) {
    setNewsData([]);
    setSelectedNews(null);
    setCurrentPageNo(1);
    setSelectedData([]);
    setTabActive(key);
    switch (key) {
      case "1":
        setStatus(4);
        break;
      case "2":
        setStatus(1);
        break;
      case "3":
        setStatus(5);
        break;
      case "4":
        setStatus(3);
        break;
      case "5":
        setStatus(0);
        break;
      default:
        setStatus(1);
        break;
    }
  }

  const fetchNews = async () => {
    setIsLoading(true);
    const response = await newsListing(
      currentPageNo,
      pageSize,
      status,
      admin_user_id,
      filterTitle,
      filterPublish,
      filterExpiry,
      filterAuthor,
      filterCategory
    );
    if (currentPageNo === 1) {
      setTotalPageNo(response?.meta?.total);
    }
    setCurrentPageNo(response?.meta?.current_page);

    const formattedData = response?.news?.map((item) => ({
      id: item?.news_id,
      title: item?.title,
      avatar: null,
      category: item?.news_category_name,
      author: item?.author_name,
      authorIcon: item?.author_image,
      publisheddate: item?.published_date || "NA",
      status: item?.news_status_flg,
      expirydate: item?.expiry_date || "NA",
      expirydatetime: item?.expiry_date_time || null,
      message: item?.message_content,
      recipients_flg: item?.recipients_flg,
      source: item?.source,
      wards: item?.wards,
      top_news: item?.top_news_flg,
      abstract_content: item?.abstract_content ? item?.abstract_content : "",
      image_caption: item?.image_caption,
      category_id: item?.news_category_id,
      activity: item?.activities,
      banner_img: item?.news_image,
      allow_resubmission_flg: item?.allow_resubmission_flg,
      author_image: item?.author_image,
      news_image_filepath: item?.news_image_filepath,
      author_image_path: item?.author_image_filepath,
      published_date_time: item.published_date_time,
      tabDate:
        tabActive === "1"
          ? item?.published_date_time
          : tabActive === "2"
          ? item?.published_date_time
          : tabActive === "3"
          ? item?.scheduled_date
          : tabActive === "4"
          ? item?.activities[0]?.date
          : "N/A",
      tag_color: item?.tag_color,
    }));
    setNewsData(formattedData);
    setIsLoading(false);
  };

  const debouncedLoadNews = useDebounce(fetchNews, 300);

  useEffect(() => {
    debouncedLoadNews();
  }, [filterTitle, filterAuthor]);

  useEffect(() => {
    fetchNews();
  }, [
    currentPageNo,
    pageSize,
    status,
    filterCategory,
    filterExpiry,
    filterPublish,
    news,
  ]);

  {
  }

  return (
    <>
      {news ? (
        <CreateNews
          approval={true}
          isDuplicate={duplicate}
          setOpen={setNews}
          open={news}
          categoryData={categoryData}
          setLoadCategory={setLoadCategory}
          selectedNews={selectedNews}
          isEdit={isEdit}
          handleTabChange={handleTabChange}
          setNews={setNews}
          setDetails={setDetails}
        />
      ) : details ? (
        <DetailsPage
          onEdit={(data) => {
            setNews(true);
            setSelectedNews(data);
            setEdit(true);
            setDuplicate(false);
          }}
          setOpen={setDetails}
          fetchNews={fetchNews}
          selectedNews={selectedNews}
          tabActive={tabActive}
          setSelectedNews={setSelectedNews}
        />
      ) : (
        <div className="page-wrapper flex flex-column gap-2">
          <div className="flex wrap gap-2 align-center justify-between">
            <h2 className="page-title">My News Article</h2>
            {isPermit(3, "create") && (
              <ButtonComp
                onClick={() => {
                  setNews(true);
                  setEdit(false);
                  setDuplicate(false);
                }}
                prefix
              >
                Create news article
              </ButtonComp>
            )}
          </div>
          {isPermit(3, "view") && (
            <TabComp
              isLoading={isLoading}
              tabActive={tabActive}
              handleTabChange={handleTabChange}
              exportData={selectedData}
              count={selectedData?.length}
              data={tabsData}
            />
          )}
        </div>
      )}
      <ModalComp
        footer={dltModalFooter}
        CancelClick={() => setDlt(false)}
        open={dlt}
        setOpen={setDlt}
        title="Delete News"
      >
        Are you sure you want to delete the news titled '{selectedNews?.title}'
      </ModalComp>
    </>
  );
}

export default NewsManagement;
